import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { InputFilterStyled } from './styled';
import { Inputs, Icons, Buttons } from 'components';
import momentTZ from 'moment-timezone';

const ALL_OPTION = { label: 'ทั้งหมด', value: '' };

const InputFilter = ({
  theme_standard_input_filter,
  dataFilter,
  onQueryFilter,
  btnLabel,
  initialValues,
  onClear,
  clearLabel = 'ล้างค่า',
}) => {
  const customClass = cx({
    theme_standard_input_filter: theme_standard_input_filter,
  });

  const [_filter, _setFilter] = useState({});
  const [_resetKey, _setResetKey] = useState(0);

  const initialValuesKey = initialValues ? JSON.stringify(initialValues) : '';

  useEffect(() => {
    if (!initialValues || !dataFilter) {
      _setFilter({});
      _setResetKey((k) => k + 1);
      return;
    }
    const seeded = {};
    dataFilter.forEach((e) => {
      const v = initialValues[e.accessor];
      if (v === undefined || v === null || v === '') return;
      if (e.filter.type === 'dateGroup') {
        if (typeof v === 'object' && v.start_date && v.end_date) {
          const typesPart = v.types ? `&types=${v.types}` : '';
          seeded[e.accessor] = {
            fieldQuery: e.filter.fieldQuery,
            name: e.accessor,
            type: e.filter.type,
            value: `start_date=${v.start_date}&end_date=${v.end_date}${typesPart}`,
          };
        }
      } else {
        seeded[e.accessor] = {
          fieldQuery: e.filter.fieldQuery,
          name: e.accessor,
          type: e.filter.type,
          value: v,
        };
      }
    });
    _setFilter(seeded);
    _setResetKey((k) => k + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValuesKey]);

  const clickFilter = () => {
    let queryArr = [];
    let query = '';
    Object.keys(_filter).forEach((key) => {
      const item = _filter[key];
      if (item.type === 'dateGroup') {
        if (item.value) queryArr.push(`${item.value}`);
      } else {
        const v = item.value == null ? '' : item.value;
        queryArr.push(`${item.fieldQuery}=${v}`);
      }
    });
    if (queryArr.length > 0) {
      query = `?${queryArr.join('&')}`;
    }
    onQueryFilter && onQueryFilter(query);
  };

  const clickClear = () => {
    _setFilter({});
    _setResetKey((k) => k + 1);
    onClear && onClear();
  };

  const onTextKeyDown = (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      clickFilter();
    }
  };

  const renderFilter = (e) => {
    const initial = initialValues ? initialValues[e.accessor] : undefined;
    switch (e.filter.type) {
      case 'text':
        return (
          <Inputs.InputTextField
            key={`txt-${_resetKey}`}
            theme_filter
            label={e.filter.label}
            placeholder={e.filter.placeholder && e.filter.placeholder}
            defaultValue={typeof initial === 'string' ? initial : ''}
            onKeyDown={onTextKeyDown}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f.target.value,
                },
              });
            }}
          />
        );

      case 'date':
        return (
          <Inputs.InputDatePikerCustom
            key={`dt-${_resetKey}`}
            label={e.filter.label}
            theme_standard_date_picker_custom
            placeholder={e.filter.placeholder && e.filter.placeholder}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: momentTZ(f).format('YYYY-MM-DD'),
                },
              });
            }}
          />
        );

      case 'dropdown': {
        const opts = e.filter.noAllOption
          ? e.filter.options
          : [ALL_OPTION, ...(e.filter.options || [])];
        return (
          <Inputs.InputDropDownFilter
            key={`dd-${_resetKey}`}
            iconSvgClose={<Icons.ArrowDropDown />}
            iconSvgOpen={<Icons.ArrowDropDown up />}
            placeholder={e.placeHolder}
            options={opts}
            value={typeof initial === 'string' ? initial : undefined}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f,
                },
              });
            }}
          />
        );
      }

      case 'label':
        return <div className={`box_label active`}>{e.labelName}</div>;

      case 'dateGroup': {
        const dgInitial = initial && typeof initial === 'object' ? initial : null;
        const mergedInitial = dgInitial
          ? {
              ...(e.filter.initialValues || {}),
              ...(dgInitial.types ? { level1: dgInitial.types } : {}),
              start_date: dgInitial.start_date,
              end_date: dgInitial.end_date,
            }
          : e.filter.initialValues;
        return (
          <Inputs.DateGroup
            key={`dg-${_resetKey}`}
            initialValues={mergedInitial}
            iconSvgClose={<Icons.ArrowDropDown />}
            iconSvgOpen={<Icons.ArrowDropDown up />}
            placeholder={e.filter.placeholder}
            options={e.filter.options}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f,
                },
              });
            }}
          />
        );
      }
      default:
        break;
    }
  };

  return (
    <InputFilterStyled>
      <div className={customClass}>
        {dataFilter &&
          dataFilter.map((e, i) => (
            <div key={i}>
              <div key={i + 1} className="box_filter">
                {e.label && <div className="label_top">{e.label}</div>}
                <div key={i} style={{ width: `${e.length}` }}>
                  {renderFilter(e)}
                </div>
              </div>
            </div>
          ))}
        <div className="btn_action_filter">
          <Buttons.BtnNormal
            theme_filter
            label={btnLabel}
            height="100%"
            onClick={clickFilter}
          />
        </div>
        {onClear && (
          <div className="btn_action_filter">
            <Buttons.BtnNormal
              theme_filter
              bgColor="#9aa3b0"
              label={clearLabel}
              height="100%"
              onClick={clickClear}
            />
          </div>
        )}
      </div>
    </InputFilterStyled>
  );
};

InputFilter.propTypes = {};

export default InputFilter;
